Ext.define('SA.view.sidebar.data.ImportsBrowseResultList', {
    alias: 'widget.imports-browse-result-list',
    extend: 'SA.view.SimpleContainer',

    hasResults() {
        return this.getChildItems().some(cmp => cmp.isVisible());
    },

    setFilter(filter) {
        this.getChildItems().forEach(cmp => cmp.setFilter(filter));

        this.setVisible(this.hasResults());
    }
});